<template>
  <div>
    <!-- PC -->
    <div class="content-box herder pc">
      <div class="header-left">
        <div class="logo-box">
          <img class="header-logo" src="../../../assets/logo.png" alt="" />
        </div>
        <div class="header-title" v-for="(item, index) in routesArr" :key="index">
          <div class="nav" v-if="!item.alwaysShow">
            <router-link class="router-link" :class="routeTarget.indexOf(item.path === '/' ? '/home' : item.path) !==
                -1
                ? 'select'
                : ''
              " :to="item.path">
              {{ item.children[0].meta.title }}
            </router-link>
            <p class="selectLine" :class="routeTarget.indexOf(item.path === '/' ? '/home' : item.path) !==
                -1
                ? 'select-line'
                : 'unselect-line'
              "></p>
          </div>

          <div class="children-title" v-if="item.alwaysShow">
            <p>
              {{ item.meta.title }}
              <span> <img src="../../../assets/Arrow@2x.png" alt="" /></span>
            </p>
            <p class="selectLine" :class="routeTarget.indexOf(item.path === '/' ? '/home' : item.path) !==
                -1
                ? 'select-line'
                : 'unselect-line'
              "></p>
            <div class="children-list" :class="item.meta.title === '产品中心'
                ? 'children-list-four'
                : item.meta.title === '关于我们'
                  ? 'children-list-two'
                  : item.meta.title === '解决方案'
                    ? 'children-list-five'
                    : ''
              ">
              <p v-for="(children, index) in item.children" :key="'children' + index" v-if="!children.hidden">
                <router-link class="children-router-link" :class="routeTarget.indexOf(item.path + '/' + children.path) !== -1
                    ? 'active'
                    : ''
                  " :to="item.path + '/' + children.path">
                  {{ children.meta.title }}
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="header-right"></div>
    </div>
    <!-- mobile -->
    <div class="mobile mobile-position">
      <div class="mobile-header">
        <img class="mobile-header-logo" src="../../../assets/logo.png" alt="" />
        <img v-if="openMenu" class="mobile-nav" src="../../../assets/mobile/close.png" alt="" @click="menuBtn" />
        <img v-else class="mobile-nav" src="../../../assets/mobile/menu.png" alt="" @click="menuBtn" />
        <div class="mobile-nav-group" v-if="openMenu" :style="{ height: clientHeight }">
          <div v-for="(item, index) in routesArr" :key="index">
            <div v-if="!item.alwaysShow" class="mobile-nav-title" @click.prevent="closechildrenBtn">
              <router-link class="always-show" :to="item.path" :class="routeTarget.indexOf(
                item.path === '/' ? '/home' : item.path
              ) !== -1
                  ? 'mobile-color'
                  : ''
                ">
                {{ item.children[0].meta.title }}
              </router-link>
            </div>

            <div v-if="item.alwaysShow" class="mobile-nav-title" @click="openChildrenNav(index)">
              <p class="always-show" :class="routeTarget.indexOf(
                item.path === '/' ? '/home' : item.path
              ) !== -1
                  ? 'mobile-color'
                  : ''
                ">
                {{ item.meta.title }}
              </p>
              <span class="children-nav">
                <img v-if="index == selectIndex" src="../../../assets/mobile/arrow-down.png" alt="" />
                <img v-if="index != selectIndex" src="../../../assets/mobile/arrow-right.png" alt="" />
              </span>
            </div>
            <div v-if="item.alwaysShow" class="mobile-children-list" :style="{
              display: index == selectIndex ? 'flex' : 'none',
            }">
              <div class="col-8" v-for="(children, index) in item.children" :key="'children' + index"
                @click="closechildren">
                <div v-if="!children.hidden">
                  <router-link class="mobile-children-router-link" :class="routeTarget.indexOf(item.path + '/' + children.path) !==
                      -1
                      ? 'mobileActive'
                      : ''
                    " :to="item.path + '/' + children.path">
                    {{ children.meta.title }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      routesArr: [],
      routeTarget: "/home",
      selectIndex: "",
      openMenu: false,
      clientHeight: "",
    };
  },
  watch: {
    $route(to, from) {
      this.routeTarget = to.path;
    },
  },
  created() {
    this.routesArr = this.$router.options.routes;
    this.routeTarget = this.$route.path;
  },
  mounted() {
    this.clientHeight = document.documentElement.clientHeight + "px";
  },
  methods: {
    menuBtn() {
      this.openMenu = !this.openMenu;
    },
    openChildrenNav(i) {
      if (this.selectIndex == i) {
        this.selectIndex = "";
      } else {
        this.selectIndex = i;
      }
    },
    closechildren() {
      this.openMenu = false;
    },
    closechildrenBtn() {
      this.openMenu = false;
      this.selectIndex = "";
    },
  },
};
</script>

<style scoped>
.herder {
  height: 64px;
}

.header-left {
  display: flex;
}

.logo-box {
  height: 64px;
  display: flex;
  align-items: center;
}

.header-logo {
  width: 80px;
  height: 24px;
  margin-right: 14px;
}

.nav {
  width: 64px;
  text-align: center;
  position: relative;
}

.selectLine {
  position: absolute;
  bottom: 0px;
  width: 64px;
  height: 2px;
  background: #ffa200;
  /* display: none; */
}

.select-line {
  display: block;
}

.unselect-line {
  display: none;
}

.header-title {
  height: 64px;
  margin-left: 32px;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  line-height: 64px;
}

.header-title:hover {
  color: #f08d00;
  font-weight: 500;
  cursor: pointer;
}

.header-right {
  margin-top: 23px;
}

.children-title {
  width: 64px;
  text-align: center;
  position: relative;
}

.arrow {
  width: 20px;
  height: 20px;
  border: 1px solid red;
}

.children-list {
  /* height: auto; */
  position: absolute;
  top: 54px;
  left: -8px;
  width: 210px;
  height: 0px;
  text-align: left;
  padding-top: 0px;
  background: #ffffff;
  z-index: 9999;
  overflow: hidden;
  transition: height 0.2s;
  -webkit-transition: height 0.2s;
}

.children-title:hover>.children-list {
  height: 110px;
  padding-top: 10px;
}

.children-title:hover>.children-list-four {
  height: 180px;
  padding-top: 10px;
}

.children-title:hover>.children-list-two {
  height: 74px;
  padding-top: 10px;
}

.children-title:hover>.children-list-five {
  height: auto;
  padding-top: 10px;
}

.router-link {
  display: inline-block;
  height: 64px;
  color: #666666;
  text-decoration: none;
}

.nav:hover>.router-link {
  color: #f08d00;
}

.select {
  color: #f08d00;
}

.children-router-link {
  display: block;
  height: 30px;
  padding-left: 13px;
  font-size: 12px;
  font-weight: 400;
  color: #515356;
  line-height: 30px;
  text-decoration: none;
}

/* .children-router-link:nth-child(5){
  margin-bottom: 20px;
} */
.children-router-link:hover {
  background: #f08d00;
  color: #ffffff;
}

.active {
  /* background: #f08d00; */
  color: #f08d00;
}
</style>

<style scoped>
@media screen and (max-width: 750px) {
  .mobile-position {
    width: 100% !important;
    width: 0.5rem;
    position: fixed;
    top: 0px;
    z-index: 2;
  }

  .mobile-header {
    /* width: 100%; */
    height: 0.88rem;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .mobile-header-logo {
    height: 0.39rem;
    margin-left: 0.32rem;
  }

  .mobile-nav {
    width: 0.39rem;
    margin-right: 0.32rem;
  }

  .mobile-nav-group {
    width: 100vw;
    position: absolute;
    top: 0.86rem;
    left: 0;
    background: #ffffff;
    z-index: 9999;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .mobile-nav-title {
    height: 1.08rem;
    line-height: 1.08rem;
    text-align: left;
    padding-left: 0.32rem;
    border-bottom: 0.01rem solid #f1f1f1;
    display: flex;
    justify-content: space-between;
  }

  .always-show {
    font-size: 0.32rem;
    font-weight: 400;
    color: #666666;
    text-decoration: none;
    width: 100%;
  }

  .children-nav {
    text-align: right;
    padding-right: 0.32rem;
  }

  .children-nav img {
    width: 0.15rem;
  }

  .mobile-children-list {
    display:  flex ;
    justify-content: start;
    flex-wrap: wrap;
    height: auto;
    /* display: flex; */
    /* flex-wrap: wrap; */
    text-align: center;
    /* overflow: hidden; */
    /* transition: height 0.2s; */
    /* -webkit-transition: height 0.2s; */
    border-bottom: 1px solid #f1f1f1;
    padding: 0.32rem 0.32rem 0 0.32rem;
  }
.mobile-children-router-link{
  width: auto !important;
}
  .col-8 {
    min-width: 33%;
    float: left;
  }

  .mobile-children-router-link {
    display: inline-block;
    text-decoration: none;
    line-height: 0.64rem;
    height: 0.64rem;
    background: #f8f9fb;
    width: 2.12rem;
    font-weight: 500;
    color: #333333;
    font-size: 0.24rem;
    border-radius: 0.08rem;
    margin-bottom: 0.24rem;
  }

  .mobileActive {
    background: #f08d00;
    border-radius: 0.08rem;
    font-size: 0.24rem;
    font-weight: 500;
    color: #ffffff;
  }

  .mobile-color {
    color: #f08d00;
  }
}
</style>
